import { route } from './route';
import { AITHORA_PREFIX } from './prefix';
import type {
  FamilyTodayActionBody,
  FamilyTodayActionResponse,
  FamilyTodayResponse,
  FamilyWeekResponse,
  FamilyVisitPlanResponse,
  FamilyVisitRequestBody,
  FamilyVisitRequestResponse,
  HelpCancelResponse,
  MyPeopleCallBody,
  MyPeopleCallResponse,
  MyPeopleResponse,
  TalkTodayResponse,
} from './mobile-types';

const A = AITHORA_PREFIX;

// The phone app's own routes (src/aithora/v3/mobile-family.ts). Session-scoped: every one works on
// the caller's own person or on a resident the caller is linked to as family.

/** GET /family/:residentId/today: the Family "Mom" tab. */
export const familyToday = route<FamilyTodayResponse>()('GET', `${A}/family/:residentId/today`, { honest: true });
/** POST /family/:residentId/today/actions: "Call" (logged), "I'll join" (the care-plan review). */
export const familyTodayAct = route<FamilyTodayActionResponse, void, FamilyTodayActionBody>()('POST', `${A}/family/:residentId/today/actions`, { honest: true });
/** GET /family/:residentId/week: Her week (meals, water, sleep, activities a day), her linked family only. */
export const familyWeek = route<FamilyWeekResponse>()('GET', `${A}/family/:residentId/week`, { honest: true });

/** GET /family/:residentId/visit-plan: next visit, visiting hours, open times, recent visits. */
export const familyVisitPlan = route<FamilyVisitPlanResponse>()('GET', `${A}/family/:residentId/visit-plan`, { honest: true });
/** POST /family/:residentId/visit-plan {at}: ask the front desk for a visit. */
export const familyVisitRequest = route<FamilyVisitRequestResponse, void, FamilyVisitRequestBody>()('POST', `${A}/family/:residentId/visit-plan`, { honest: true });

/** GET /me/people: the person's own people, for the Family tab. */
export const myPeople = route<MyPeopleResponse>()('GET', `${A}/me/people`, { honest: true });
/** POST /me/people/:personId/call {video?}: dial them, or ask them to video call back. */
export const myPeopleCall = route<MyPeopleCallResponse, void, MyPeopleCallBody>()('POST', `${A}/me/people/:personId/call`, { honest: true });

/** POST /me/help/cancel: "I'm all right" after "I need help" (Aithora Home). */
export const helpCancel = route<HelpCancelResponse, void, Record<string, never>>()('POST', `${A}/me/help/cancel`, { honest: true });

/** GET /me/talk: today's conversation with Atlas (the person's own). */
export const talkToday = route<TalkTodayResponse>()('GET', `${A}/me/talk`, { honest: true });
